module.exports = __webpack_public_path__ + "static/media/logo.38256e06.svg";